
import apiConfig from "../../../api/api.config"
import apiService from "../../../api/api.service"
import tokenService from "../../../api/token.service"
import { ApiResponse } from "../../../types/api.store.types"
import { LoginCredentials, LoginResponse } from "../types/auth.types"

class AuthService {
  private currentUser: LoginResponse['user'] | null = null

  /**
   * Login user and store tokens
   */
  public async login(credentials: LoginCredentials): Promise<LoginResponse> {
    try {
      const response = await apiService.post<ApiResponse<LoginResponse>>(
        apiConfig.endpoints.auth.login,
        credentials
      )

      const loginData = response.responseObject

      const { accessToken, refreshToken, expiresIn, user } = loginData

      // Store tokens
      tokenService.setTokens(accessToken, refreshToken, expiresIn)

      tokenService.setUserData(loginData)

      // Store user info
      this.setCurrentUser(user)
      return loginData
    } catch (error) {
      throw error
    }
  }

  /**
   * Logout user and clear tokens
   */
  public logout(): void {
    tokenService.clearTokens()
    this.currentUser = null
    window.location.href = '/singin'
  }

  /**
   * Get current user information
   */
  public getCurrentUser(): LoginResponse['user'] | null {
    return this.currentUser
  }

  /**
   * Set current user information
   */
  private setCurrentUser(user: LoginResponse['user']): void {
    this.currentUser = user
  }

  /**
   * Check if user is authenticated
   */
  public isAuthenticated(): boolean {
    return tokenService.isAuthenticated()
  }
}

export const authService = new AuthService()
export default authService
